// extracted by mini-css-extract-plugin
export default {"container":"universalCMSApp__container__DTSHj","error":"universalCMSApp__error__zjhKR","content":"universalCMSApp__content__LLx4q"};